import React, { useState } from "react";
import "./Payroll.css";
import MobileLayout from "../../../layouts/MobileLayout";

const PayrollPage = () => {
  const [activeTab, setActiveTab] = useState("payslips");

  // Dummy data (replace with API response)
  const payslips = [
    {
      id: 1,
      month: "March 2026",
      uploaded: "25 March 2026",
      gross: "₹85,000",
      net: "₹64,450",
    },
    {
      id: 2,
      month: "February 2026",
      uploaded: "25 Feb 2026",
      gross: "₹85,000",
      net: "₹67,200",
    },
  ];

  return (
    <MobileLayout>
    
    </MobileLayout>


  );
};

export default PayrollPage;